export const CREATE_TOPIC = `mutation CreateTopic(
  $tenant_id: Int!,
  $input: CreateTopicInput!,
  $file: Upload
) {
  createTopic(
    tenant_id: $tenant_id,
    input: $input,
    file: $file
  ) {
    __typename
    ... on Topic {
      id
      title
      description
      category_id
      subcategory_id
      materials
      video_link
      presentation_file
      active
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
      exhibitor {
        id
        type
        contact {
          id
          firstname
          lastname
        }
      }
      category {
        id
        name
        is_active
      }
      subcategory {
        id
        name
        is_active
      }
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const UPDATE_TOPIC = `mutation UpdateTopic(
  $tenant_id: Int!,
  $input: UpdateTopicInput!,
  $file: Upload
) {
  updateTopic(
    tenant_id: $tenant_id,
    input: $input,
    file: $file
  ) {
    __typename
    ... on Topic {
      id
      title
      description
      category_id
      subcategory_id
      materials
      video_link
      presentation_file
      active
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
      exhibitor {
        id
        type
        contact {
          id
          firstname
          lastname
        }
      }
      category {
        id
        name
        is_active
      }
      subcategory {
        id
        name
        is_active
      }
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const DELETE_TOPIC = `mutation DeleteTopic(
  $tenant_id: Int!,
  $id: Int!
) {
  deleteTopic(
    tenant_id: $tenant_id,
    id: $id
  ) {
    __typename
    ... on Topic {
      id
      title
      description
      category_id
      subcategory_id
      materials
      video_link
      presentation_file
      active
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
      exhibitor {
        id
        type
        contact {
          id
          firstname
          lastname
        }
      }
      category {
        id
        name
        is_active
      }
      subcategory {
        id
        name
        is_active
      }
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;
